export default function domain() {
  // return "http://localhost:8000/web";
  // return "http://127.0.0.1:8000/web";
  return "https://api.campaigningtool.com/web";
}
